import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { WebApiService } from "../../../_libs/web-api";
import { BaseWebApiService } from "./-base-webapi.service";

@Injectable({
	providedIn: "root",
})
export class MuleHotlistCheckService extends BaseWebApiService {
	constructor(private webApiService: WebApiService) {
		super();
	}

	public muleHotlistCheck(uri: string, bodyObj): Observable<any> {
		const type = "post";
		const url = "partymgmt/eligibility";
		const body = bodyObj;

		const tempBody = {
			correlationId: body.quoteId,
			channel: "DODO",
			characteristics: [
				{
					name: "creditAmountRequired",
					value: "100",
				},
				{
					name: "purpose",
					value: "Mobile_One_Platform",
				},
			],
			parties: [
				{
					gender: "MALE",
					birthDate: body.aboutYou.dob.split("/").reverse().join("-"),
					title: "MR",
					givenName: body.aboutYou.firstName,
					familyName: body.aboutYou.lastName,
					middleName: "Aa",
					partyCharacteristic: [
						{
							name: "applicantType",
							value: "PRIMARY_APPLICANT",
						},
					],
					contactMedium: [
						{
							mediumType: "Phone",
							phoneNumber: body.aboutYou.mobile
								.split(" ")
								.join(""),
						},
						{
							mediumType: "HomePhone",
							areaCode: "02",
							phoneNumber: "84004500",
						},
						{
							mediumType: "WorkPhone",
							areaCode: "02",
							phoneNumber: "94004500",
						},
						{
							mediumType: "Email",
							emailAddress: body.aboutYou.email,
						},
						{
							mediumType: "CurrentAddress",
							locId: body.LocId,
						},
					],
				},
			],
		};

		if (type === "post") {
			return this.webApiService.postMS(url, tempBody);
		} else {
			return this.webApiService.putMS(url, tempBody);
		}
	}
}
